import { styled } from '@ori-ui/mui';
import React from 'react';

export interface PopupHeaderProps {
    title: string;
}

const Root = styled('p')(({ theme }) => ({
    margin: '0 0 30px',
    color: theme.palette.grey[600],
    fontSize: 20,
    fontWeight: 'bold',
    lineHeight: '29px',
    textAlign: 'center',
}));

export const PopupHeader: React.FC<PopupHeaderProps> = ({ title }) => <Root>{title}</Root>;
